import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import React from 'react';

export const DriverContainer = (props) => {
    const {t, element, validator, handleChange, driverOpt} = props;
    return element.transportType ? (
        <div className='row'>
            <InputDropdownComponent
                id='driver'
                name='driver'
                label={t('order-fuel.driver')}
                colClass='col-lg-4 col-md-8 col-sm-12'
                value={element.driver}
                viewMode='EDIT'
                validator={validator}
                validators='required'
                options={driverOpt}
                onChange={handleChange}
                dataKey='sapId'
                optionLabel='fullName'
                filter
                filterBy='fullName'
            />
            {element.driver ? (
                <React.Fragment>
                    <InputTextComponent
                        id='pesel'
                        name='pesel'
                        label={t('driver.pesel')}
                        colClass='col-lg-4 col-md-8 col-sm-12'
                        value={element?.driver.pesel}
                        viewMode={'EDIT'}
                        validator={validator}
                        validators='required'
                        onChange={handleChange}
                        disabled
                        rendered={element.driver !== null}
                    />
                    <InputTextComponent
                        id='documentNumber'
                        name='documentNumber'
                        label={t('driver.documentNumber')}
                        colClass='col-lg-4 col-md-8 col-sm-12'
                        value={element?.driver.documentNumber}
                        viewMode={'EDIT'}
                        validator={validator}
                        validators='required'
                        onChange={handleChange}
                        disabled
                        rendered={element.driver !== null}
                    />
                </React.Fragment>
            ) : null}
        </div>
    ) : null;
};
